export function formatMoney(n: number | string | null | undefined): string {
  const num = typeof n === "string" ? parseFloat(n) : (n ?? 0);
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    maximumFractionDigits: 2,
  }).format(Number(num) || 0);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatRelativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return "just now";
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}

export const DAMAGE_TYPE_LABELS: Record<string, string> = {
  SPINE_BROKEN: "Spine broken",
  COVER_DAMAGED: "Cover damaged",
  PAGES_LOOSE: "Pages loose",
  PAGES_TORN: "Pages torn",
  WATER_DAMAGE: "Water damage",
  MOLD: "Mold",
  AGING: "Aging",
  OTHER: "Other",
};

export const REPAIR_TYPE_LABELS: Record<string, string> = {
  REBIND: "Rebind",
  RECASE: "Recase",
  SPINE_REPAIR: "Spine repair",
  COVER_REPAIR: "Cover repair",
  PAGE_REPAIR: "Page repair",
  CLEANING: "Cleaning",
  OTHER: "Other",
};

export const DEGREE_LEVEL_LABELS: Record<string, string> = {
  UG_FINAL: "Undergrad Final Year",
  MASTERS: "Master's",
  PHD: "PhD",
};

export const BINDING_TYPE_LABELS: Record<string, string> = {
  SOFT: "Soft-cover",
  HARD: "Hard-cover",
  GOLD_EMBOSS: "Hard-cover w/ gold emboss",
};

export const THESIS_PAYMENT_METHOD_LABELS: Record<string, string> = {
  CASH: "Cash (library desk)",
  BANK_TRANSFER: "Bank transfer",
  POS: "Card / POS",
  PAYSTACK: "Paystack",
  FLUTTERWAVE: "Flutterwave",
  OTHER: "Other",
};

export const THESIS_STATUS_LABELS: Record<string, string> = {
  SUBMITTED: "Submitted",
  FORMAT_CHECK: "Format check",
  APPROVED: "Approved — awaiting payment",
  PRINTING: "Printing",
  BINDING: "Binding",
  READY: "Ready for pickup",
  COLLECTED: "Collected",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};
